import { accountDetails, http } from "@mainDi/webDi";
import actions from "./action";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
var cRepositorires = repositories(http, accountDetails);
var cUseCases = useCases(cRepositorires);
var cActions = actions();
var cPresenters = presenters(cUseCases, cActions);
export default {
    postLogin: cPresenters.postLogin,
};
